(function () {
  'use strict';

  if (!document.body.classList.contains('template-product')) return;
  if (window.innerWidth >= 768) return;

  var bar     = document.getElementById('stickyAtc');
  var titleEl = document.getElementById('stickyAtcTitle');
  var sizeEl  = document.getElementById('stickyAtcSize');
  var btn     = document.getElementById('stickyAtcBtn');

  if (!bar || !titleEl || !sizeEl || !btn) return;

  var productTitle = document.querySelector('.product-title');
  if (productTitle) titleEl.textContent = productTitle.textContent.trim();

  var originalBtn = document.querySelector('.add-to-cart');
  if (!originalBtn) return;

  // Read variant data from variant-picker embedded JSON
  var variantPicker = document.querySelector('variant-picker');
  var variants = [];
  if (variantPicker) {
    var jsonScript = variantPicker.querySelector('script[type="application/json"]');
    if (jsonScript) {
      try {
        variants = JSON.parse(jsonScript.textContent).variants || [];
      } catch (e) {}
    }
  }

  if (variants.length && variantPicker) {
    // Build options from option1 (size), marking unavailable ones
    var seen = {};
    variants.forEach(function (v) {
      var size = v.option1;
      if (!seen[size]) {
        seen[size] = { available: false };
      }
      if (v.available) seen[size].available = true;
    });

    Object.keys(seen).forEach(function (size) {
      var opt = document.createElement('option');
      opt.value = size;
      opt.textContent = size;
      if (!seen[size].available) opt.disabled = true;
      sizeEl.appendChild(opt);
    });

    // Sync initial value with whatever is already checked in the main form
    var checkedRadio = variantPicker.querySelector('input.js-option:checked');
    if (checkedRadio) sizeEl.value = checkedRadio.value;

    // Sticky select change → click the matching radio in the main form
    sizeEl.addEventListener('change', function () {
      var allRadios = variantPicker.querySelectorAll('input.js-option');
      for (var i = 0; i < allRadios.length; i++) {
        if (allRadios[i].value === sizeEl.value && !allRadios[i].checked) {
          allRadios[i].click();
          break;
        }
      }
    });

    // Main form radio change → sync sticky select
    variantPicker.querySelectorAll('input.js-option').forEach(function (radio) {
      radio.addEventListener('change', function () {
        sizeEl.value = radio.value;
      });
    });
  } else {
    sizeEl.style.display = 'none';
  }

  // Show / hide sticky bar based on original button, footer AND cart drawer
  var btnVisible    = false;
  var footerVisible = false;
  var cartOpen      = false;
  var navOpen       = false;
  var scrolledEnough = false;

  window.addEventListener('scroll', function() {
    scrolledEnough = window.scrollY > 80;
    updateBar();
  }, { passive: true });

  function updateBar() {
    if (!scrolledEnough || btnVisible || footerVisible || cartOpen || navOpen) {
      bar.classList.remove('sticky-atc--visible');
    } else {
      bar.classList.add('sticky-atc--visible');
    }
  }

  new IntersectionObserver(function (entries) {
    btnVisible = entries[0].isIntersecting;
    updateBar();
  }, { threshold: 0 }).observe(originalBtn);

  var footer = document.getElementById('pagefooter');
  if (footer) {
    new IntersectionObserver(function (entries) {
      footerVisible = entries[0].isIntersecting;
      updateBar();
    }, { threshold: 0 }).observe(footer);
  }

  var cartDrawer = document.querySelector('.js-cart-drawer');
  if (cartDrawer) {
    new MutationObserver(function () {
      cartOpen = cartDrawer.hasAttribute('open');
      updateBar();
    }).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
  }

  new MutationObserver(function() {
    navOpen = document.body.classList.contains('reveal-mobile-nav');
    updateBar();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Sticky button → click original add-to-cart (carries the selected variant)
  btn.addEventListener('click', function () {
    originalBtn.click();
  });

})();
